var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.158 13.817L10.975 10 7.158 6.175 8.333 5l5 5-5 5-1.175-1.183z"
  })));
};
export default SvgChevronRight;